let VideoTabModule = {
  params: {
    _API_KEY: 'd5eac8413279e13eb76d349de5e8a8a4',
    _API_ADMIN_KEY: 'secret',
    _ENDPOINT: 'https://visionnocturnaytermica.myshopify.com/api/2023-01/graphql.json',
    _ADMIN_ENDPOINT: 'https://visionnocturnaytermica.myshopify.com/admin/api/2023-01/graphql.json',
    attemps: 0
  },
  functions: {
    init: () => {
      VideoTabModule.functions.fetchVideoData();
      VideoTabModule.functions.fetchFeatures();
      //VideoTabModule.functions.enableMetafieldVisibility();
    },

    /**
     * 
     */
    enableMetafieldVisibility: () => {
      //Perform API request
      fetch(VideoTabModule.params._ADMIN_ENDPOINT, {
        method: 'POST',
        cache: 'no-cache', //default for production
        headers: {
          'Content-Type': 'application/graphql',
          'X-Shopify-Access-Token': VideoTabModule.params._API_ADMIN_KEY
        },
        body: JSON.stringify(`
            query {
              mutation {
                metafieldStorefrontVisibilityCreate(
                  input: {
                    namespace: "custom"
                    key: "features"
                    ownerType: PRODUCT
                  }
                ) {
                  metafieldStorefrontVisibility {
                    id
                  }
                  userErrors {
                    field
                    message
                  }
                }
              }
            }
            `)
      })
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          console.log(data);
        })
        .catch((error) => console.error(error));
    },

    /**
     * This function will download the features metafield and will set into the HTML
     */
    fetchFeatures: () => {
      //First, get the product handle
      let handle = document.querySelector('#features-product-container');
      if (typeof handle == 'undefined' || handle == null) {
        if (VideoTabModule.params.attemps < 10) {
          VideoTabModule.params.attemps++;
          //Delay execution and re-try
          window.setTimeout(VideoTabModule.functions.fetchFeatures, 1000);
          console.log('Re-trying: ', VideoTabModule.params.attemps);
          return;
        }
      }

      //Build query
      let query = `
        {
          product(handle: "` + handle.getAttribute('data-product-handle') + `") {
            features: metafield(namespace: "custom", key: "features") {
              id
              value
              type
            }
          }
        }
      `;

      //Perform API request
      fetch(VideoTabModule.params._ENDPOINT, {
        method: 'POST',
        cache: 'no-cache', //default for production
        headers: {
          'Content-Type': 'application/graphql',
          'X-Shopify-Storefront-Access-Token': VideoTabModule.params._API_KEY
        },
        body: query
      })
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          data = JSON.parse(data);
          if (data.data.product.features != null) {
            let text = data.data.product.features.value;

            //First, check if the text has any value
            if (text == null || text == '') {
              //Hide the parent
              document.querySelector('#features-product-container').parentElement.parentElement.parentElement.remove();
              return;
            }

            //Now replace all line jumps \n with <br>
            text = text.replace(/\n/g, '<br>');

            document.querySelector('#features-product-container').innerHTML = text;
          } else {
              document.querySelector('#features-product-container').parentElement.parentElement.parentElement.remove();
          }
        })
        .catch((error) => console.error(error));
    },
    /**
     * This function will download the video metafield data and will insert it into the HTML
     */
    fetchVideoData: () => {
      //First, get the product handle
      let handle = document.querySelector('#video-product-container');
      if (typeof handle == 'undefined' || handle == null) {
        if (VideoTabModule.params.attemps < 10) {
          VideoTabModule.params.attemps++;
          //Delay execution and re-try
          window.setTimeout(VideoTabModule.functions.fetchVideoData, 1000);
          console.log('Re-trying: ', VideoTabModule.params.attemps);
          return;
        }
      }

      //Build query
      let query = `
        {
          product(handle: "` + handle.getAttribute('data-product-handle') + `") {
            video_embed: metafield(namespace: "custom", key: "video_embed") {
              id
              value
              type
            }
          }
        }
      `;

      //Perform API request
      fetch(VideoTabModule.params._ENDPOINT, {
        method: 'POST',
        cache: 'no-cache', //default for production
        headers: {
          'Content-Type': 'application/graphql',
          'X-Shopify-Storefront-Access-Token': VideoTabModule.params._API_KEY
        },
        body: query
      })
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          VideoTabModule.functions.convertToVideoURLs(data);
        })
        .catch((error) => console.error(error));
    },

    /**
     *
     */
    convertToVideoURLs: (data) => {
      data = JSON.parse(data);
      if (data.data.product.video_embed != null) {
        //Check if the product has a video, if not hide the parent
        let video = data.data.product.video_embed.value;
        if (video == null || video == '') {
          //Hide the parent
          document.querySelector('#video-product-container').parentElement.parentElement.parentElement.remove();
        }
        document.querySelector('#video-product-container').innerHTML = video;
      } else {
          document.querySelector('#video-product-container').parentElement.parentElement.parentElement.remove();
      }
    }
  }
};

VideoTabModule.functions.init();